import React, {useEffect} from 'react';
import {getConfig} from './firebase';


function HomeScreen({}) {
  const [userData, setUserData] = React.useState(null)
  const [isAuth] = React.useState(!!localStorage.getItem("userData"));
  const [copiedAddress, setCopiedAddress] = React.useState(null);
  const [tokenAddresses, setTokenAddresses] = React.useState({
    carrot: '0xd952d34a55ff231f65932cabe73cb8f8b7febdc7',
    stick: '0x001158c4e7abb4b1ae54edbcb697a98e3db0cb61',
    magic: '0x247cc1502d850925da627cb373560bd0adf90760'
  });
  const [loadingAddresses, setLoadingAddresses] = React.useState(true);
  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    } else {
      setUserData(null);
    }

    // Fetch token addresses from Firebase
    const fetchTokenAddresses = async () => {
      try {
        const config = await getConfig();
        if (config && config.tokens) {
          setTokenAddresses({
            carrot: config.tokens.carrot || '0xd952d34a55ff231f65932cabe73cb8f8b7febdc7',
            stick: config.tokens.stick || '0x001158c4e7abb4b1ae54edbcb697a98e3db0cb61',
            magic: config.tokens.magic || '0x247cc1502d850925da627cb373560bd0adf90760'
          });
        }
      } catch (error) {
        console.error('Error fetching token addresses:', error);
        // Keep default addresses if fetch fails
      } finally {
        setLoadingAddresses(false);
      }
    };

    fetchTokenAddresses();
  }, []);
  const logOut = () => {
    localStorage.removeItem("userData");
    window.location.href = "/";
  }

  const handleCopyAddress = (address, tokenName) => {
    navigator.clipboard.writeText(address);
    setCopiedAddress(tokenName);
    setTimeout(() => {
      setCopiedAddress(null);
    }, 2000);
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-black/80 to-yellow-500 bg-fixed">
      {/* Header */}
      <header className="bg-black text-yellow-400 py-3 sm:py-5 shadow-lg border-b border-yellow-400/60 sticky top-0 z-50">
        <div className="mx-auto max-w-4xl px-3 sm:px-4 flex items-center justify-between">
          <a
            href="/"
            className="flex items-center gap-1 sm:gap-2 rounded-lg px-1 sm:px-2 py-1 hover:bg-yellow-400 hover:text-black transition"
          >
            <span className="text-xl sm:text-2xl md:text-3xl">🥕🪵</span>
            <h1 className="text-sm sm:text-lg md:text-2xl font-bold leading-none">Carrot & Stick</h1>
          </a>
          {isAuth ? (
            <button
              onClick={logOut}
              className="bg-yellow-400 text-black px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-lg font-bold hover:bg-yellow-300 transition border border-black text-xs sm:text-sm"
            >
              Logout
            </button>
          ) : (
            <a
              href="/"
              className="rounded-lg px-2 sm:px-3 py-1 sm:py-1.5 hover:bg-yellow-400 hover:text-black transition text-xs sm:text-sm"
            >
              Login
            </a>
          )}
        </div>
      </header>

      {/* Page container */}
      <main className="mx-auto max-w-4xl px-3 sm:px-4 py-4 sm:py-6 md:py-10">
        {/* Welcome / wrapper card */}
        <section
          className="bg-black/95 rounded-xl sm:rounded-2xl shadow-2xl p-3 sm:p-4 md:p-6 lg:p-8 border-2 sm:border-4 border-yellow-400/80">
          {/* Title */}
          <div className="text-center mb-4 sm:mb-5 md:mb-6">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-extrabold text-yellow-400 tracking-tight">
              Welcome to the Game! 🎮
            </h2>

            {userData && (
              <div className="mt-2 space-y-1">
                <p className="text-xs sm:text-sm md:text-base text-yellow-200 break-words">
                  Registered as: <span className="font-bold text-yellow-400">{userData.email}</span>
                </p>
                <p className="text-xs sm:text-sm text-yellow-200/90">
                  Twitter: @{userData.twitter_screen_name}
                </p>
              </div>
            )}
          </div>

          {/* How to play */}
          <div className="space-y-4 sm:space-y-5 md:space-y-6">
            <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-center text-yellow-400">
              🎯 How to Play (It's Simple!)
            </h3>

            {/* Step 1 */}
            <article className="bg-yellow-400 border-2 sm:border-4 border-black rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-6">
              <div className="flex flex-col sm:flex-row items-start gap-2 sm:gap-3 md:gap-4">
                <div className="text-2xl sm:text-3xl md:text-5xl leading-none">🥕</div>
                <div className="flex-1">
                  <h4 className="text-base sm:text-lg md:text-2xl font-extrabold text-black mb-1 sm:mb-1.5 md:mb-2">
                    Shill Us on Twitter! 🚀
                  </h4>
                  <p className="text-black text-xs sm:text-sm md:text-base leading-relaxed">
                    Go to Twitter and <span className="font-bold">TAG</span> our project with your most creative,
                    funny, or degenerate praise! 🎭
                  </p>
                  <div className="mt-2 sm:mt-3 bg-black rounded-lg p-2 sm:p-3 md:p-4 border border-yellow-300">
                    <p className="text-xs sm:text-sm text-yellow-300 mb-1">Example tweet:</p>
                    <p className="italic text-yellow-100 text-xs sm:text-sm break-words">
                      "Just found @carrotvsstick 🥕🪵 This is the next 100x gem!
                      Wen lambo? Wen moon? WAGMI! 🚀🌙 #CARROTvsSTICK #ToTheMoon"
                    </p>
                  </div>
                </div>
              </div>
            </article>

            {/* CTA */}
            <div className="text-center">
              <a
                  href="https://twitter.com/intent/tweet?text=Just%20joined%20@carrotvsstick%20🥕🪵%20This%20is%20fire!%20%23CARROTvsSTICK"
                  target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-1 sm:gap-2 bg-yellow-400 text-black text-sm sm:text-base md:text-xl
                       font-bold px-4 sm:px-6 md:px-8 py-2 sm:py-3 md:py-4 rounded-full shadow-lg hover:shadow-xl
                       hover:scale-[1.02] transition-all border-2 sm:border-4 border-black"
              >
                🐦 Tweet About Us Now! 🚀
              </a>
            </div>

            {/* Step 2 – Carrot Path */}
            <article className="bg-black border-2 sm:border-4 border-yellow-400 rounded-xl p-4 sm:p-6 shadow-lg">
              <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
                <div className="text-4xl sm:text-6xl animate-bounce leading-none">🥕</div>
                <div className="flex-1">
                  <h4 className="text-lg sm:text-2xl font-bold text-yellow-400 mb-2">
                    The CARROT Path 🎁 (Good Vibes Only!)
                  </h4>
                  <p className="text-yellow-100 text-sm mb-2">
                    If your tweet is <span
                    className="font-bold text-yellow-300">creative, funny, or makes us laugh</span>,
                    our boss will personally send <span className="font-bold text-yellow-300">$CARROT tokens</span> to
                    your wallet! 🎉
                  </p>
                  <div className="bg-yellow-400 rounded-lg p-3 sm:p-4 border border-yellow-500">
                    <p className="font-bold text-black text-center text-base sm:text-xl">
                      🏆 Best Shill = FREE CARROTS! 🥕💰
                    </p>
                  </div>
                </div>
              </div>
            </article>

            {/* Step 3 – Stick Path */}
            <article className="bg-black border-2 sm:border-4 border-yellow-400 rounded-xl p-4 sm:p-6 shadow-lg">
              <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
                <div className="text-4xl sm:text-6xl animate-bounce leading-none">🪵</div>
                <div className="flex-1">
                  <h4 className="text-lg sm:text-2xl font-bold text-yellow-400 mb-2">
                    The STICK Path ⚠️ (FUD at Your Own Risk!)
                  </h4>
                  <p className="text-yellow-100 text-sm mb-2">
                    If you <span className="font-bold text-red-400">FUD us, say bad things, or spread negativity</span>,
                    you'll get <span className="font-bold text-red-400">$STICK tokens</span> sent to your wallet
                    instead! 🪵😈
                  </p>
                  <div className="bg-yellow-400 rounded-lg p-3 sm:p-4 border border-red-500">
                    <p className="font-bold text-black text-center text-base sm:text-xl">
                      ⚠️ FUD = GET STICKED! 🪵💥
                    </p>
                  </div>
                </div>
              </div>
            </article>

            {/* Step 4 – Magic Path */}
            <article className="bg-black border-2 sm:border-4 border-yellow-400 rounded-xl p-4 sm:p-6 shadow-lg">
              <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
                <div className="text-4xl sm:text-6xl animate-bounce leading-none">🪄</div>
                <div className="flex-1">
                  <h4 className="text-lg sm:text-2xl font-bold text-yellow-400 mb-2">
                    The MAGIC Path ✨ (The Great Escape!)
                  </h4>
                  <p className="text-yellow-100 text-sm mb-2">
                    Got too many <span className="font-bold text-red-400">$STICK tokens</span>? Feeling stuck?
                    Use <span className="font-bold text-yellow-400">$MAGIC</span> to banish your
                    <span className="font-bold text-red-400"> $STICK tokens</span>! Once your
                    <span className="font-bold text-red-400"> $STICK</span> balance is zero,
                    the path to sending <span className="font-bold text-yellow-300">$CARROT tokens</span> will be clear! 🪄✨
                  </p>
                  <div className="bg-yellow-400 rounded-lg p-3 sm:p-4 border border-yellow-500">
                    <p className="font-bold text-black text-center text-base sm:text-xl">
                      ✨ Cast a Spell = Send STICK Away! 🪄💫
                    </p>
                  </div>
                </div>
              </div>
            </article>

            {/* Token Addresses */}
            <article className="bg-black border-2 sm:border-4 border-yellow-400 rounded-lg sm:rounded-xl p-3 sm:p-4 md:p-6">
              <h4 className="text-base sm:text-lg md:text-xl font-bold text-yellow-400 mb-3 sm:mb-4 text-center">🪙 Token Addresses</h4>
              <div className="space-y-2 sm:space-y-3">
                {/* CARROT */}
                <div className="bg-yellow-400/20 rounded-lg p-2 sm:p-3 border border-yellow-400">
                  <div className="flex items-center gap-1 sm:gap-2 mb-1">
                    <span className="text-lg sm:text-xl">🥕</span>
                    <span className="font-bold text-xs sm:text-sm text-white">$CARROT</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="font-mono text-xs sm:text-sm text-yellow-100 break-all flex-1">
                      {loadingAddresses ? 'Loading...' : tokenAddresses.carrot}
                    </p>
                    <div className="flex gap-1">
                      <button
                        onClick={() => handleCopyAddress(tokenAddresses.carrot, 'CARROT')}
                        className="px-2 py-1 hover:bg-yellow-400/30 rounded transition-colors text-xs"
                        title="Copy address"
                      >
                        {copiedAddress === 'CARROT' ? 'Copied!' : '📋'}
                      </button>
                      <button
                        onClick={() => window.open(`https://bscscan.com/address/${tokenAddresses.carrot}`, '_blank')}
                        className="p-1 hover:bg-yellow-400/30 rounded transition-colors"
                        title="Open in explorer"
                      >
                        🔗
                      </button>
                    </div>
                  </div>
                </div>

                {/* STICK */}
                <div className="bg-purple-500/20 rounded-lg p-2 sm:p-3 border border-purple-400">
                  <div className="flex items-center gap-1 sm:gap-2 mb-1">
                    <span className="text-lg sm:text-xl">🪵</span>
                    <span className="font-bold text-xs sm:text-sm text-white">$STICK</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="font-mono text-xs sm:text-sm text-red-100 break-all flex-1">
                      {loadingAddresses ? 'Loading...' : tokenAddresses.stick}
                    </p>
                    <div className="flex gap-1">
                      <button
                        onClick={() => handleCopyAddress(tokenAddresses.stick, 'STICK')}
                        className="px-2 py-1 hover:bg-purple-400/30 rounded transition-colors text-xs"
                        title="Copy address"
                      >
                        {copiedAddress === 'STICK' ? 'Copied!' : '📋'}
                      </button>
                      <button
                        onClick={() => window.open(`https://bscscan.com/address/${tokenAddresses.stick}`, '_blank')}
                        className="p-1 hover:bg-purple-400/30 rounded transition-colors"
                        title="Open in explorer"
                      >
                        🔗
                      </button>
                    </div>
                  </div>
                </div>

                {/* MAGIC */}
                <div className="bg-red-500/20 rounded-lg p-2 sm:p-3 border border-red-400">
                  <div className="flex items-center gap-1 sm:gap-2 mb-1">
                    <span className="text-lg sm:text-xl">🪄</span>
                    <span className="font-bold text-xs sm:text-sm text-white">$MAGIC</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="font-mono text-xs sm:text-sm text-purple-100 break-all flex-1">
                      {loadingAddresses ? 'Loading...' : tokenAddresses.magic}
                    </p>
                    <div className="flex gap-1">
                      <button
                        onClick={() => handleCopyAddress(tokenAddresses.magic, 'MAGIC')}
                        className="px-2 py-1 hover:bg-red-400/30 rounded transition-colors text-xs"
                        title="Copy address"
                      >
                        {copiedAddress === 'MAGIC' ? 'Copied!' : '📋'}
                      </button>
                      <button
                        onClick={() => window.open(`https://bscscan.com/address/${tokenAddresses.magic}`, '_blank')}
                        className="p-1 hover:bg-red-400/30 rounded transition-colors"
                        title="Open in explorer"
                      >
                        🔗
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </article>

            {/* Boss decides */}
            <article className="bg-yellow-400 border-2 sm:border-4 border-black rounded-xl p-4 sm:p-6 text-center">
              <p className="text-xl sm:text-2xl font-extrabold text-black mb-1.5">👑 THE BOSS DECIDES! 👑</p>
              <p className="text-sm sm:text-base text-black">
                Our boss will personally review all tweets and decide who gets
                <span className="text-green-700 font-bold"> 🥕 CARROTS </span>
                or
                <span className="text-red-700 font-bold"> 🪵 STICKS</span>!
              </p>
              <p className="text-xs sm:text-sm text-black mt-2 italic">
                (Yes, this is totally fair and not at all arbitrary 😉)
              </p>
            </article>

            {/* Notes */}
            <article className="bg-black border-2 sm:border-4 border-yellow-400 rounded-xl p-4 sm:p-6">
              <h4 className="text-lg sm:text-xl font-bold text-yellow-400 mb-2">📝 Important Notes:</h4>
              <ul className="space-y-2 text-yellow-100 text-sm sm:text-base">
                {userData && (
                  <li className="flex items-start gap-2 flex-wrap">
                    <span className="text-lg flex-shrink-0">✅</span>
                    <div className="flex-1 min-w-0 leading-relaxed text-yellow-100">
                      <span>Your wallet address:&nbsp;</span>
                      <span
                        className="inline-block font-mono bg-yellow-400 text-black px-2 py-1 rounded break-all w-full sm:w-auto">
                    {userData.wallet_address}
                  </span>
                    </div>
                  </li>
                )}
                <li className="flex items-start gap-2"><span className="text-lg ">✅</span><span
                  className={'text-yellow-100'}>Be creative! Memes are encouraged! 🎨</span></li>
                <li className="flex items-start gap-2"><span className="text-lg">✅</span><span
                  className={'text-yellow-100'}>Tag us properly so we can find your tweet!</span></li>
                <li className="flex items-start gap-2"><span className="text-lg">⚠️</span><span
                  className={'text-yellow-100'}>Negative tweets = You get sticked! (But hey, at least you get something 😂)</span>
                </li>
              </ul>
            </article>

            {/* Disclaimer */}
            <article className="bg-black border-2 sm:border-4 border-red-500 rounded-xl p-4 sm:p-6">
              <h4 className="text-lg sm:text-xl font-bold text-red-400 mb-3 text-center">⚠️ Disclaimer</h4>
              <div className="space-y-3 text-yellow-100 text-xs sm:text-sm leading-relaxed">
                <p className="text-yellow-200">
                  By participating in <span className="font-bold text-yellow-400">Carrot vs Stick: The Game</span>, you acknowledge and agree to the following:
                </p>

                <p className="flex items-start gap-2">
                  <span className="flex-shrink-0">🥕🪵🪄</span>
                  <span><span className="font-semibold">$CARROT</span>, <span className="font-semibold">$STICK</span>, and <span className="font-semibold">$MAGIC</span> tokens have <span className="font-bold text-red-400">no monetary value</span>, no guarantees of appreciation, and may go to zero at any time.</span>
                </p>

                <p className="flex items-start gap-2">
                  <span className="flex-shrink-0">🎲</span>
                  <span>Token distribution, rewards, and penalties are <span className="font-bold text-yellow-400">entirely arbitrary</span> and may change at any time without notice.</span>
                </p>

                <p className="flex items-start gap-2">
                  <span className="flex-shrink-0">✉️</span>
                  <span>By connecting your wallet and linking your Google and X (Twitter) accounts, you <span className="font-bold text-yellow-400">consent to the collection and use</span> of your email, Twitter handle, and wallet address for marketing and communication purposes by the project team and its partners.</span>
                </p>

                <p className="flex items-start gap-2">
                  <span className="flex-shrink-0">🪙 </span>
                  <span>The project is for <span className="font-bold text-yellow-400">entertainment and community engagement only</span>. It should not be considered an investment, financial product, or solicitation of any kind.</span>
                </p>

                <p className="flex items-start gap-2">
                  <span className="flex-shrink-0">⚖️</span>
                  <span>Participation is optional. You play at your own risk — but hopefully for fun.</span>
                </p>

                <div className="mt-4 pt-3 border-t border-yellow-400/30 text-center">
                  <p className="italic text-yellow-300">
                    In short: this is a <span className="font-bold text-yellow-400">meme game</span>. It might make you laugh, it might get you sticked, but it definitely isn't financial advice. 😉
                  </p>
                </div>
              </div>
            </article>
          </div>
        </section>

        {/* Footer */}
        <footer className="text-center py-4 sm:py-6 px-3">
          <p className="text-black/90 italic text-sm sm:text-base md:text-lg font-bold">
            "In Carrot & Stick we trust" 🥕🪵
          </p>
          <p className="text-black/80 text-xs sm:text-sm mt-1 sm:mt-1.5">
            Disclaimer: This is probably a scam. But a fun one! 😉
          </p>
        </footer>
      </main>
    </div>
  );
}

export default HomeScreen;
